<template>
    <div>
        <vs-popup
                class="deliverer-modal"
                title="Invoiceable bewerken"
                :active.sync="showPopup"
                v-if="invoiceAble !== null"
        >
            <template>
                <div class="vx-row">
                    <div class="vx-col sm:w-1/2 w-full mb-2">
                        <vs-input
                                class="w-full"
                                label="Aantal"
                                :value="invoiceAble.quantity"
                                v-model="invoiceAble.quantity"
                        />
                    </div>
                    <div class="vx-col sm:w-1/2 w-full mb-2">
                        <vs-input
                                class="w-full"
                                label="Prijs"
                                :value="invoiceAble.price"
                                v-model="invoiceAble.price"
                        />
                    </div>
                </div>
                <div class="vx-col">
                    <vs-textarea v-model="invoiceAble.description"></vs-textarea>
                </div>

                <div class="vx-col">
                    <div class="vx-row">
                        <div class="vx-col w-full mb-2">

                            <v-select :options="companies" v-model="company" label="name"
                            >
                                <vs-select-item :text="item.name" v-for="item in companies"/>
                            </v-select>

                        </div>
                    </div>
                </div>

                <div class="vx-col">

                    <vs-button
                            class="mr-3 mb-2 vs-con-loading__container"
                            id="save-invoiceable-button"
                            ref="loadableButton"
                            @click="saveInvoiceable"
                            :disabled="canSave"
                            style="float: right"
                    >Opslaan
                    </vs-button>
                </div>
            </template>
        </vs-popup>
        <vs-popup
                class="deliverer-modal"
                title="Invoiceable bewerken"
                :active.sync="showCreatePopup"
                v-if="createInvoiceable !== null"
        >
            <template>
                <div class="vx-row">
                    <div class="vx-col sm:w-1/2 w-full mb-2">
                        <vs-input
                                class="w-full"
                                label="Aantal"
                                :value="createInvoiceable.quantity"
                                v-model="createInvoiceable.quantity"
                        />
                    </div>
                    <div class="vx-col sm:w-1/2 w-full mb-2">
                        <vs-input
                                class="w-full"
                                label="Prijs"
                                :value="createInvoiceable.price"
                                v-model="createInvoiceable.price"
                        />
                    </div>
                </div>
                <div class="vx-col">
                    <vs-textarea v-model="createInvoiceable.description"></vs-textarea>
                </div>
                <div class="vx-col">
                    <div class="vx-row">
                        <div class="vx-col w-full mb-2">

                            <v-select :options="companies" v-model="company" label="name"
                            >
                                <vs-select-item :text="item.name" v-for="item in companies"/>
                            </v-select>

                        </div>
                    </div>
                </div>

                <div class="vx-col">
                    <vs-button
                            class="mr-3 mb-2 vs-con-loading__container"
                            id="create-invoiceable-button"
                            ref="loadableButton"
                            @click="createInvoiceableModal"
                            :disabled="canSave"
                            style="float: right"
                    >Opslaan
                    </vs-button>
                </div>
            </template>
        </vs-popup>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                showPopup: false,
                showCreatePopup: false,
                invoiceAble: null,
                loading: false,
                companies: [],
                company: null,
                createInvoiceable: {
                    price: 0,
                    quantity: 1,
                    description: '',
                }
            };
        },
        computed: {
            canSave() {
                return this.loading;
            }
        },
        watch: {
            showPopup: function () {
                if (this.showPopup) {
                    this.companies.map((company) => {
                        if (company.id === this.invoiceAble.company.id) {
                            this.company = company;
                        }
                    });
                }
            }
        },
        methods: {
            saveInvoiceable() {
                this.$util.loading('#save-invoiceable-button', this.$vs);
                this.loading = true;
                let data = new FormData();
                data.append('_method', 'PUT');
                data.append('id', this.invoiceAble.id);
                data.append('price', this.invoiceAble.price);
                data.append('quantity', this.invoiceAble.quantity);
                data.append('description', this.invoiceAble.description);
                data.append('company_id', this.company.id);
                this.$http
                    .post("v1/invoice-able/update", data, {
                        headers: {
                            Authorization:
                                "Bearer " + JSON.parse(localStorage.getItem("stafftoken")),
                        },
                    })
                    .then(() => {
                        this.showPopup = false;
                        this.loading = false;
                        this.$vs.loading.close('#save-invoiceable-button > .con-vs-loading');
                        this.$util.notify('Gelukt', 'Invoiceable is aangepast en opgeslagen!', this.$vs);
                    })
                    .catch((error) => {
                        this.$vs.loading.close("#save-deliverer-button > .con-vs-loading");
                        this.loading = false;
                        this.$util.logError(error, this.$vs);
                    });
            },
            createInvoiceableModal() {
                this.$util.loading('#create-invoiceable-button', this.$vs);
                this.loading = true;
                let data = new FormData();
                data.append('_method', 'POST');
                data.append('price', this.createInvoiceable.price);
                data.append('quantity', this.createInvoiceable.quantity);
                data.append('description', this.createInvoiceable.description);
                data.append('company_id', this.company.id);
                this.$http
                    .post("v1/invoice-able/create", data, {
                        headers: {
                            Authorization:
                                "Bearer " + JSON.parse(localStorage.getItem("stafftoken")),
                        },
                    })
                    .then(() => {
                        this.showCreatePopup = false;
                        this.loading = false;
                        this.$vs.loading.close('#create-invoiceable-button > .con-vs-loading');
                        this.$events.fire('refresh-invoiceables');
                        this.$util.notify('Gelukt', 'Invoiceable is aangemaakt en opgeslagen!', this.$vs);
                    })
                    .catch((error) => {
                        this.$vs.loading.close("#create-invoiceable-button > .con-vs-loading");
                        this.loading = false;
                        this.$util.logError(error, this.$vs);
                    });
            },
            getInvoiceableCompanies() {
                this.$http
                    .get("v1/invoice-able/companies", {
                        headers: {
                            Authorization:
                                "Bearer " + JSON.parse(localStorage.getItem("stafftoken")),
                        },
                    })
                    .then((response) => {
                        this.companies = response.data;
                    })
                    .catch((error) => {

                        this.$util.logError(error, this.$vs);
                    });
            },
        },

        mounted() {
            this.$events.listen('open-invoiceable-modal', (invoiceAble) => {
                this.invoiceAble = invoiceAble;
                this.showPopup = true;
            });
            this.$events.listen('open-invoiceable-create-modal', () => {
                this.showCreatePopup = true;
            });
            this.getInvoiceableCompanies();
            window.addEventListener('keyup', (key) => {
                if (key.keyCode === 27) {
                    this.showPopup = false;
                }
            });
        }
    };
</script>